<template>
  <div
    class="modal fade"
    :ref="`modal-product-detail`"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{
              $t(
                serviceData.id === 0
                  ? "service.addNewService"
                  : "service.serviceDetail"
              )
            }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group required">
                <label class="control-label" for="">{{
                  $t("service.service_code")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="serviceData.serviceCode"
                  :disabled="serviceData.isBuiltin"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label class="control-label" for="">{{
                  $t("service.serviceList.serviceName")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="serviceData.serviceName"
                  :disabled="serviceData.isBuiltin"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group required">
                    <label class="control-label" for="">{{
                      $t("service.serviceUnit")
                    }}</label>
                    <!-- <v-select
                      class="clear"
                      :options="serviceUnitList"
                      :reduce="data => data.id"
                      :getOptionLabel="option => $t(option.serviceUnit)"
                      :placeholder="$t('service.serviceUnit')"
                      v-model="serviceData.serviceUnit"
                    >
                      <template v-slot:option="option">
                        {{ $t(option.serviceUnit) }}
                      </template>
                    </v-select> -->
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="$t('service.serviceUnit')"
                      v-model="serviceData.serviceUnit"
                      :disabled="serviceData.isBuiltin"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="checkboxEnable"
                        v-model="serviceData.enable"
                        :disabled="serviceData.isBuiltin"
                      />
                      <label class="form-check-label" for="checkboxEnable">{{
                        $t("common.enable")
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="checkboxShowOnMobile"
                        v-model="serviceData.showOnMobile"
                        :disabled="(!isUpdateShowOnMobile && !serviceData.showOnMobile) || serviceData.isBuiltin"
                      />
                      <label class="form-check-label" for="checkboxShowOnMobile">{{
                        $t("service.showDefaultOnMobile")
                      }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">{{ $t("apartmentGroup.description") }}</label>
                    <textarea
                      class="form-control"
                      name=""
                      id=""
                      cols="30"
                      rows="3"
                      v-model="serviceData.serviceDescription"
                      :disabled="serviceData.isBuiltin"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label required" for="">{{
                      $t("banner.image")
                    }}</label>
                    <div>
                      <img
                        id="apartment-img-id"
                        class="asset-img-class img-responsive"
                        :src="!isNull(serviceData.imgUrl) ? serviceData.imgUrl : noImgDefault"
                        alt="asset-img"
                        @click="serviceData.isBuiltin ? '' : onOpenInputImgFile()"
                      />
                      <div style="padding-top: 6px; text-align: center">
                        <input
                          :id="`upload-service-img`"
                          type="file"
                          accept="image/*"
                          @change="onSelectAssetImg"
                        />
                        <p>
                          <small>{{
                            $t("banner.clickImageToAddOrUpdate")
                          }}</small>
                        </p>
                        <span
                          v-if="!isNull(serviceData.imgUrl)"
                          class="remove-asset-img"
                          @click="onClickRemoveApartmentImg"
                          >{{ $t("common.delete") }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label required" for="">{{
                      $t("service.iconAppMobile")
                    }}</label>
                    <div>
                      <img
                        id="apartment-img-id"
                        class="asset-img-class img-responsive"
                        :src="
                          serviceData.iconMobile !== null &&
                          serviceData.iconMobile !== ''
                            ? serviceData.iconMobile
                            : noImgDefault
                        "
                        alt="asset-img"
                        @click="serviceData.isBuiltin ? '' : onOpenInputIconMobile()"
                      />
                      <div style="padding-top: 6px; text-align: center">
                        <input
                          :id="`upload-service-img`"
                          type="file"
                          accept="image/gif"
                          @change="onSelectAssetImg"
                        />
                        <p>
                          <small>{{
                            $t("banner.clickImageToAddOrUpdate")
                          }}</small>
                        </p>
                        <span
                          v-if="
                            serviceData.iconMobile !== null &&
                              serviceData.iconMobile !== ''
                          "
                          class="remove-asset-img"
                          @click="onClickRemoveIconMobile"
                          >{{ $t("common.delete") }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="box-footer">
              <!-- <div class="row"> -->
              <button
                style="background-color: #f29911;border-color: #f29911;color:#fff"
                type="button"
                class="btn btn-default pull-left"
                data-dismiss="modal"
              >
                {{ $t("common.back") }}
              </button>
              <button
                type="button"
                class="btn btn-primary pull-right"
                @click="onSave"
              >
                {{ $t("common.save") }}
              </button>
              <!-- </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.back") }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSave">
            {{ $t("common.save") }}
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import utils, { uploadFileToMediaAgent } from "@/lib/utils";
import configuration from "@/lib/config";
import { mapActions, mapGetters } from "vuex";
import constantsData from "@/lib/constantsData";

// import ServiceAttribute from "./ServiceAttribute";
export default {
  components: {
    // ServiceAttribute
  },
  data: () => ({
    noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
    serviceImgFileSize: null,
    serviceImgFile: null,
    serviceData: {
      id: 0,
      serviceCode: null,
      serviceName: null,
      serviceGroup: null,
      // serviceUnit: null,
      serviceDescription: null,
      serviceType: 2,
      imgUrl: null,
      enable: false,
      serviceUnit: null,
      iconMobile: null,
      showOnMobile: false,
      isBuiltin: false
    },
    isUpdateShowOnMobile: false,
    serviceUnitList: [],
    serviceGroupList: [],
    uploadServiceType: null,
    uploadServiceImg: 1,
    uploadServiceIcon: 2, 
    serviceTypeList: constantsData.serviceTypeList
  }),
  watch: {
    GET_SERVICE_GROUP_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_SERVICE_GROUP_LIST_NO_PAGE_DATA;
      this.serviceGroupList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          serviceGroupName: value.name,
          description: value.description
        };
        this.serviceGroupList.push(item);
      });
    },
    GET_SERVICE_UNIT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_SERVICE_UNIT_LIST_NO_PAGE_DATA;
      this.serviceUnitList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          serviceUnit: value.name,
          description: value.description
        };
        this.serviceUnitList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SERVICE_GROUP_LIST_NO_PAGE_DATA",
      "GET_SERVICE_UNIT_LIST_NO_PAGE_DATA"
    ])
  },
  methods: {
    onShowAddNew: function(isUpdateShowOnMobile) {
      $(this.$refs[`modal-product-detail`]).modal("show");
      this.serviceData = {
        id: 0,
        serviceCode: null,
        serviceName: null,
        serviceGroup: null,
        // serviceUnit: null,
        serviceDescription: null,
        serviceType: 2,
        imgUrl: null,
        enable: false,
        serviceUnit: null,
        iconMobile: null,
        isBuiltin: false
      };
      this.isUpdateShowOnMobile = isUpdateShowOnMobile
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-product-detail`]).modal("show");
      this.serviceData = {
        id: data.id,
        serviceCode: data.serviceCode,
        serviceName: data.serviceName,
        serviceGroup: data.serviceGroup,
        // serviceUnit: data.serviceUnit,
        serviceDescription: data.serviceDescription,
        serviceType: data.serviceType,
        imgUrl: data.imgUrl,
        enable: data.enable,
        serviceUnit: data.serviceUnit,
        iconMobile: data.iconMobile,
        showOnMobile: data.showOnMobile,
        isBuiltin: data.isBuiltin
      };
      this.isUpdateShowOnMobile = data.isUpdateShowOnMobile
    },
    onCloseModal: function() {
      $(this.$refs[`modal-product-detail`]).modal("hide");
    },
    validateData: function() {
      let validateResult = "OK";
      if (utils.isEmptyString(this.serviceData.serviceCode)) {
        validateResult = this.$t("service.service_code");
      } else if (utils.isEmptyString(this.serviceData.serviceName)) {
        validateResult = this.$t("service.serviceList.serviceName");
      }
      return validateResult;
    },
    isNull: function (value) {
      return utils.isNull(value)
    },
    onSave: async function() {
      let result = this.validateData();
      if (result === "OK") {
        let data = {
          id: this.serviceData.id,
          name: this.serviceData.serviceName,
          service_group: this.serviceData.serviceGroup,
          code: this.serviceData.serviceCode,
          // service_unit: this.serviceData.serviceUnit,
          description: this.serviceData.serviceDescription,
          serviceType: this.serviceData.serviceType,
          enable: this.serviceData.enable,
          imgUrl: this.serviceData.imgUrl,
          serviceUnit: this.serviceData.serviceUnit,
          showOnMobile: this.serviceData.showOnMobile,
          iconMobile: this.serviceData.iconMobile
        };
        if (this.serviceData.id === 0) {
          this.CREATE_SERVICE_V2(data)
            .then(
              function(res) {
                this.onCloseModal();
                this.$emit("callbackGetService");
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_SERVICE_V2(data)
            .then(
              function(res) {
                this.onCloseModal();
                this.$emit("callbackGetService");
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      } else {
        this.showError(result);
      }
    },
    showError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    onOpenInputSelectFile: function() {
      $(`#upload-service-img`).val("");
      $(`#upload-service-img`).click();
    },
    onSelectAssetImg: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.serviceImgFileSize = files[0].size;
      if (this.uploadServiceType === this.uploadServiceImg) {
        this.serviceData.imgUrl = URL.createObjectURL(files[0]);
      }
      if (this.uploadServiceType === this.uploadServiceIcon) {
        this.serviceData.iconMobile = URL.createObjectURL(files[0]);
      }
      await this.uploadImgFunction();
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.serviceImgFile = file;
    },
    onClickRemoveApartmentImg: function() {
      this.serviceData.imgUrl = null;
    },
    uploadImgFunction: async function() {
      if (this.serviceImgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let imgUrl = await uploadFileToMediaAgent(this.serviceImgFile, "homeMobileApp")
        if (this.uploadServiceType === this.uploadServiceImg) {
          this.serviceData.imgUrl = imgUrl;
        }
        if (this.uploadServiceType === this.uploadServiceIcon) {
          this.serviceData.iconMobile = imgUrl;
        }
      }
    },
    onOpenInputImgFile: function() {
      this.uploadServiceType = this.uploadServiceImg
      this.onOpenInputSelectFile()
    },
    onOpenInputIconMobile: function() {
      this.uploadServiceType = this.uploadServiceIcon
      this.onOpenInputSelectFile()
    },
    onClickRemoveIconMobile: function() {
      this.serviceData.iconMobile = null
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      "CREATE_SERVICE_V2",
      "UPDATE_SERVICE_V2"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}
.form-group.required .control-label:after {
  content: " *";
  color: red;
  position: absolute;
  margin-left: 8px;
  top: 0px;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 150px;
  max-height: 150px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/ApartmentServiceDetail.vue